import React, { useEffect } from 'react';
import { useParams, Switch, Route } from 'react-router-dom';
import Content from 'src/layout/content/Content';
import { Block } from "src/components/Component";
import { Card } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Auth } from "aws-amplify";
import { API_ROUTES } from 'src/config/api';
import { useSelector } from "react-redux";
import { parseFullName } from 'parse-full-name';
import Skeleton from 'react-loading-skeleton';

import { BanknotesIcon, UserCircleIcon, BriefcaseIcon, LinkIcon } from '@heroicons/react/24/outline';

import CustomerInformation from './views/information';
import CustomerPayments from './views/payments';
import CustomerBookings from './views/bookings';
import CustomerPaymentLinks from './views/payment-links';

import Axios from 'axios';

const Customer = () => {
  const { id } = useParams();
  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState({});
  const { organisation } = useSelector((state) => state);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);

      const user = await Auth.currentAuthenticatedUser();

      const result = await Axios(
        API_ROUTES.agent['customer:get'](id),
        {
          method: 'get',
          headers: { Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}` },
        }
      );

      setData(result.data.data);
      setLoading(false);
    };

    fetch();
  }, [organisation.organisation]);

  return (
    <React.Fragment>
      <Content>

        <Block>
          <Card className="border -mt-10 -mx-8">

          {loading && (
              <div className=' px-12 pt-8 pb-4'>
                <Skeleton count={1} height="50px" className="mb-2" />
              </div>
            )}

            {!loading && (
              <div className=' px-12 pt-10 pb-6'>
                <h2 className='text-violet-800 text-3xl font-thin block float-left'>{ parseFullName(data.customer_name).first.toUpperCase() }<strong className='font-bold'> { parseFullName(data.customer_name).last.toUpperCase() }</strong></h2>
              </div>
            )}


            <ul className="nav nav-tabs nav-tabs-mb-icon nav-tabs-card !px-12">
              <li
                className={`nav-item ${window.location.pathname === `/customer/${id}`
                  ? "active current-page"
                  : ""
                  } `}
              >
                <Link
                  to={`/customer/${id}`}
                  className={`nav-link
                    ${window.location.pathname === `/customer/${id}` ? "active" : ""}
                  `}
                >
                  <UserCircleIcon className="h-5 w-5 mr-1" />
                  <span>Customer Information</span>
                </Link>
              </li>
              <li
                className={`nav-item ${window.location.pathname === `/customer/${id}/payment-links`
                  ? "active current-page"
                  : ""
                  } `}
              >
                <Link
                  to={`/customer/${id}/payment-links`}
                  className={`nav-link
                    ${window.location.pathname === `/customer/${id}/payment-links` ? "active" : ""}
                  `}
                >
                  <LinkIcon className="h-5 w-5 mr-1" />
                  <span>Payment Links</span>
                </Link>
              </li>
              <li
                className={`nav-item ${window.location.pathname === `/customer/${id}/payments`
                  ? "active current-page"
                  : ""
                  } `}
              >
                <Link
                  to={`/customer/${id}/payments`}
                  className={`nav-link
                    ${window.location.pathname === `/customer/${id}/payments` ? "active" : ""}
                  `}
                >
                  <BanknotesIcon className="h-5 w-5 mr-1" />
                  <span>Payments</span>
                </Link>
              </li>
              <li
                className={`nav-item ${window.location.pathname === `/customer/${id}/bookings`
                  ? "active current-page"
                  : ""
                  } `}
              >
                <Link
                  to={`/customer/${id}/bookings`}
                  className={`nav-link
                    ${window.location.pathname === `/customer/${id}/boookings` ? "active" : ""}
                  `}
                >
                  <BriefcaseIcon className="h-5 w-5 mr-1" />
                  <span>Bookings</span>
                </Link>
              </li>
            </ul>
            <div className='px-4'>
            <Switch>
              <Route
                exact
                path={`/customer/:id/`}
                render={() => <CustomerInformation customerID={id} loading={loading} data={data} />}
              />
              <Route
                exact
                path={`/customer/:id/payments`}
                render={() => <CustomerPayments customerID={id} />}
              />
              <Route
                exact
                path={`/customer/:id/bookings`}
                render={() => <CustomerBookings customerID={id} />}
              />
              <Route
                exact
                path={`/customer/:id/payment-links`}
                render={() => <CustomerPaymentLinks customerID={id} />}
              />
            </Switch>
            </div>
          </Card>
        </Block>
      </Content >
    </React.Fragment >
  );
}

export default Customer;
